export default __webpack_public_path__ + "static/media/challenge-hover.84b92d62.svg";